import { render } from "./MandatoryExam.vue?vue&type=template&id=0dca5a32"
import script from "./MandatoryExam.vue?vue&type=script&lang=ts"
export * from "./MandatoryExam.vue?vue&type=script&lang=ts"

import "./MandatoryExam.vue?vue&type=style&index=0&id=0dca5a32&lang=css"
script.render = render

export default script